import React, { useEffect, useState } from "react";
import { Hash, Loader2, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

const PROVIDERS = [
  { id: "heuristic", label: "Heuristic (LLM, free)", hint: "Uses Optivize Universal LLM — no extra key needed." },
  { id: "dataforseo", label: "DataForSEO (paid)", hint: "Real keyword data — login + password from app.dataforseo.com" },
];

export default function AdminSEOIntegrations() {
  const [provider, setProvider] = useState("heuristic");
  const [login, setLogin] = useState("");
  const [pwd, setPwd] = useState("");
  const [current, setCurrent] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get("/seo/integrations");
      setCurrent(data);
      setProvider(data.provider || "heuristic");
    } catch { /* silent */ }
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/seo/integrations", {
        provider,
        dataforseo_login: login || undefined,
        dataforseo_password: pwd || undefined,
      });
      toast.success("SEO integration saved");
      setPwd("");
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Save failed");
    } finally { setSaving(false); }
  };

  return (
    <div className="card p-6" data-testid="seo-integrations-card">
      <div className="flex items-center gap-2 text-blue-400 text-xs uppercase tracking-wider"><Hash size={14}/> SEO Suite</div>
      <h3 className="text-xl font-bold text-white mt-1" style={{fontFamily:'Outfit'}}>Keyword Data Provider</h3>
      <p className="text-slate-400 text-sm mt-1">
        Choose where keyword research pulls data from. Heuristic is free and uses the LLM.
        Plug in DataForSEO credentials to upgrade every keyword run to real SERP data.
      </p>

      <div className="grid sm:grid-cols-2 gap-3 mt-4">
        {PROVIDERS.map(p => (
          <button
            key={p.id}
            onClick={() => setProvider(p.id)}
            className={`text-left p-4 rounded-xl border transition-colors ${
              provider === p.id ? "border-blue-500 bg-blue-500/10" : "border-slate-700 bg-slate-900/50 hover:border-slate-600"
            }`}
            data-testid={`seo-provider-${p.id}`}
          >
            <div className="text-white font-semibold text-sm">{p.label}</div>
            <div className="text-slate-400 text-xs mt-1">{p.hint}</div>
            {current?.provider === p.id && (
              <div className="text-emerald-400 text-[10px] mt-2 uppercase tracking-wider">Active</div>
            )}
          </button>
        ))}
      </div>

      {provider === "dataforseo" && (
        <div className="mt-4 grid sm:grid-cols-2 gap-3">
          <div>
            <label className="label flex items-center gap-1.5"><KeyRound size={12}/> DataForSEO login</label>
            <input
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              placeholder={current?.dataforseo_login || "email@yourcompany.com"}
              className="input w-full"
              data-testid="seo-dfs-login"
            />
          </div>
          <div>
            <label className="label flex items-center gap-1.5"><KeyRound size={12}/> DataForSEO password / API key</label>
            <input
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              type="password"
              placeholder={current?.dataforseo_password ? `${current.dataforseo_password} (kept on save)` : "••••••••"}
              className="input w-full"
              data-testid="seo-dfs-pwd"
            />
          </div>
        </div>
      )}

      <div className="mt-4">
        <button onClick={save} disabled={saving} className="btn-primary inline-flex items-center gap-2" data-testid="seo-integrations-save">
          {saving ? <Loader2 size={14} className="animate-spin"/> : null} Save
        </button>
      </div>
    </div>
  );
}
